<ds-modal
  #qouteModal
  [dimensionsConfig]="{ width: '820px' }"
  [ds-modal-trigger-for]="qouteModal"
  [(isModalOpen)]="qouteModalIsOpen"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    NSCOU Demonstrator Quote
  </ds-box-header>
  <ds-box-content>
    <div style="display: flex; flex-wrap: wrap; gap: 20px">
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold"
          >Date of Quotation:</span
        >
        <span>{{ demoQuoteResponse.quoteDate }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold">Expiry Date: </span>
        <span>{{ demoQuoteResponse.expiryDate }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold">Customer Name: </span>
        <span>{{ demoQuoteResponse.customer }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold"
          >Vehicle Description:
        </span>
        <span>{{ demoQuoteResponse.modelDescription }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold">E-Series: </span>
        <span>{{ demoQuoteResponse.series }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold"
          >Vehicle Body no.:
        </span>
        <span>{{ demoQuoteResponse.bodyno }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold"
          >Days from Retail:
        </span>
        <span>{{ demoQuoteResponse.daysFromRetail }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold"
          >Registration Date:
        </span>
        <span>{{ demoQuoteResponse.registrationDate }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold">Mileage: </span>
        <span>{{ demoQuoteResponse.mileage }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold">Price Estimate:</span>
        <span
          ><b>R{{ demoQuoteResponse.estimatedPrice }}</b></span
        >
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold">Requestor: </span>
        <span>{{ demoQuoteResponse.requestorName }}</span>
      </div>
      <div
        style="
          flex: 1;
          min-width: 250px;
          display: flex;
          align-items: flex-start;
        "
      >
        <span style="min-width: 160px; font-weight: bold"
          >Requestor Email:
        </span>
        <span>{{ demoQuoteResponse.requestorEmail }}</span>
      </div>
      <div style="flex: 1; min-width: 250px">
        <span></span>
        <span>{{ demoQuoteResponse.disclaimer }}</span>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="defleetQuote()"
    >
      Accept and Request De-fleet
    </button>
  </ds-box-footer>
</ds-modal>
